// Approved wording for a failed sign-in (MARCC-651). Shown centred on screen, not in a toast.
export const INVALID_LOGIN_MESSAGE =
  "Incorrect username or password. Click Forgot Password to reset your password. If you don’t have an email address associated with your account, please contact your manager/supervisor for assistance.";

// The .NET API answers "That username or password is not right. Check both and try again." for a
// wrong password and for an unknown account alike. Locked-out, access-turned-off and expired
// temporary password are also 401s with their own text, so this matches the wording, not just the
// status. If that API message is ever reworded, update this prefix or the guidance silently stops
// appearing and the user falls back to the API's own text in a toast.
const API_INVALID_CREDENTIALS_PREFIX = "That username or password is not right";

export const isInvalidCredentialsError = (
  status: number | undefined,
  message: unknown
): boolean =>
  status === 401 &&
  typeof message === "string" &&
  message.startsWith(API_INVALID_CREDENTIALS_PREFIX);
